// src/pages/SuccessPage.jsx
import React, { useEffect } from "react";

/* -----------------------------
   Meta Pixel (inline helper)
----------------------------- */
const PIXEL_ID = "24921128320812912";
let _pixelLoaded = false;

function loadMetaPixel() {
  if (typeof window === "undefined") return;

  if (!_pixelLoaded) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = "https://connect.facebook.net/en_US/fbevents.js";
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script");

    _pixelLoaded = true;
    window.fbq("init", PIXEL_ID);
  }

  // Fire PageView for this page load
  window.fbq("track", "PageView");
}

function fbqTrackCustom(event, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", event, params);
  }
}

/* -----------------------------
   Component
----------------------------- */
export default function SuccessPage() {
  useEffect(() => {
    // Load Meta Pixel and mark this page view distinctly
    loadMetaPixel();

    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      // Distinguishable page marker
      window.fbq("track", "ViewContent", {
        content_name: "SuccessPage",
        page_path: window.location.pathname,
        page_title: "Thank you",
      });

      // Standard conversion signal for ad platforms
      window.fbq("track", "Lead");

      // Analyst-friendly custom conversion name
      fbqTrackCustom("LeadConfirmed", { method: "debt_form" });
    }

    // Keep your existing GA/gtag conversion for redundancy
    if (window.gaEvent) {
      window.gaEvent("generate_lead", { method: "debt_form" });
    } else if (window.gtag) {
      window.gtag("event", "generate_lead", { method: "debt_form" });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FB]">
      <main className="w-full max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-12 sm:py-16">
        <div className="max-w-xl mx-auto bg-white border border-[#e9ecf3] rounded-2xl shadow-sm p-6 sm:p-8 text-center">
          <div
            className="w-14 h-14 mx-auto mb-4 rounded-full bg-[#ecfdf5] grid place-items-center"
            aria-hidden="true"
          >
            <svg
              className="w-8 h-8 text-[#065f46]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="font-extrabold text-[24px] sm:text-[32px] leading-tight text-[#0f172a]">
            Thank you!
          </h1>
          <p className="text-[#1A2040] text-[14px] sm:text-[17px] mt-2">
            We’ve received your request. Our team will contact you soon.
          </p>

          <div className="h-px bg-[#e9ecf3] my-6" />

          <p className="mt-3 text-xs sm:text-sm text-gray-500">
            Need help now?{" "}
            <a
              href="tel:8882230171"
              className="text-[#0057B8] hover:text-[#003e7e] underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD600] rounded"
            >
              Call (888) 223-0171
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
